import { Card } from '@keboola/design';

/** The markdown snippets the original lists beside the long-description editor, verbatim. */
const SNIPPETS: readonly string[] = [
  '*Italic*',
  '**Bold**',
  '## Heading 2',
  '### Heading 3',
  '[Link](https://a.com)',
  '![Image](https://url/a.png)',
  '> Blockquote',
  '* List item',
  '1. Numbered item',
  '`Inline code`',
  '``` fenced code block ```',
];

/** Markdown cheat sheet for the two description fields. */
export function MarkdownHelp() {
  return (
    <Card>
      <Card.Header>
        <Card.Title as="h3">Markdown syntax</Card.Title>
      </Card.Header>
      <Card.Content className="tw:flex tw:flex-col tw:gap-1">
        {SNIPPETS.map((snippet) => (
          <code key={snippet} className="tw:font-mono tw:text-xs tw:text-muted-foreground">
            {snippet}
          </code>
        ))}
        <a
          href="https://commonmark.org/help/"
          target="_blank"
          rel="noopener noreferrer"
          className="tw:mt-2 tw:text-sm tw:text-primary"
        >
          Full CommonMark reference
        </a>
      </Card.Content>
    </Card>
  );
}
